export const authTypes = {
	setUser: "SET_USER",
	setUserProfile: "SET_USER_PROFILE",
	destroySession: "DESTROY_SESSION",
};
